import { Box } from "@mui/material";
import styled from "styled-components/macro";

export const StyledRadarKey = styled.div`
  position: absolute;
  width: 100px;
  margin-top: 50px;
  margin-left: -40px;
  text-align: left;
  div.key-item {
    font-size: 16px;
  }
  div.title {
    font-size: 20px;
    margin-bottom: 14px;
  }
  div {
    margin-bottom: 14px;
    svg {
      margin-right: 8px;
    }
  }
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

interface KeyCircleProps {
  color1: string;
  color2: string;
  color3: string;
}

const KeyCircle = ({ color1, color2, color3 }: KeyCircleProps) => (
  <svg width={24} height={24}>
    <circle cx={12} cy={12} r={12} fill={color1} />
    <circle cx={12} cy={12} r={8} fill={color2} />
    <circle cx={12} cy={12} r={4} fill={color3} />
  </svg>
);

const RadarKey = () => {
  return (
    <StyledRadarKey>
      <div className="title">Key</div>
      <Box className="key-item" sx={{ display: "flex" }}>
        <KeyCircle color1={"#c4c4c41a"} color2={"#e6236d"} color3={"#222222"} />
        <span className="key-text">Learning</span>
      </Box>

      <Box className="key-item" sx={{ display: "flex" }}>
        <KeyCircle color1={"#e6236d"} color2={"#290738"} color3={"#391A46"} />
        <span className="key-text">Preferred</span>
      </Box>
    </StyledRadarKey>
  );
};

export default RadarKey;
